import styled from "styled-components";

export const TailNumber = ({ tail, color = null }) => {
	return (
		<div style={{ display: "flex" }}>
			<Container color={color}>{tail ?? "_"}</Container>
		</div>
	);
};

const Container = styled.div`
	padding: 3px 6px;
	border: 1px solid ${({ color }) => (color ? color : "#e9e8e8")};
	border-radius: 6px;
	min-width: 64px;
	font-size: 12px;
	font-weight: 700;
	line-height: 16px;
	text-align: center;
	letter-spacing: 0.5px;
	color: ${({ color }) => (color ? color : "#595959")};
	white-space: nowrap;
`;
